const LOCAL_DATE_INPUT_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * HTML `input[type=date]` returns a local calendar date as `YYYY-MM-DD` (no timezone in the string).
 * These helpers interpret that date in the user's local timezone and convert to UTC ISO 8601
 * (`Date.prototype.toISOString()`), for Activity Handler filters.
 */
function parseLocalCalendarDateComponents(ymd: string): {
    year: number;
    monthIndex: number;
    day: number;
} | null {
    const m = LOCAL_DATE_INPUT_PATTERN.exec(ymd.trim());
    if (!m) {
        return null;
    }
    const year = Number(m[1]);
    const monthIndex = Number(m[2]) - 1;
    const day = Number(m[3]);
    const probe = new Date(year, monthIndex, day, 12, 0, 0, 0);
    if (
        probe.getFullYear() !== year ||
        probe.getMonth() !== monthIndex ||
        probe.getDate() !== day
    ) {
        return null;
    }
    return { year, monthIndex, day };
}

/** Start of the user's local calendar day → UTC ISO string. */
export function localCalendarDateInputToUtcIsoStartOfDay(ymd: string): string | null {
    const parts = parseLocalCalendarDateComponents(ymd);
    if (!parts) {
        return null;
    }
    const { year, monthIndex, day } = parts;
    return new Date(year, monthIndex, day, 0, 0, 0, 0).toISOString();
}

/** End of the user's local calendar day → UTC ISO string (23:59:59.999 local). */
export function localCalendarDateInputToUtcIsoEndOfDay(ymd: string): string | null {
    const parts = parseLocalCalendarDateComponents(ymd);
    if (!parts) {
        return null;
    }
    const { year, monthIndex, day } = parts;
    return new Date(year, monthIndex, day, 23, 59, 59, 999).toISOString();
}
